import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function BlankSpace() {
  return (
    <Box sx={{ height: '1%', maxHeight: 5 }}>
      <Typography variant="h6" component="div" gutterBottom>
      </Typography>
    </Box>
  );
}